var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"d-flex fill-height justify-center\n",attrs:{"fluid":""}},[_c('v-btn',{on:{"click":_vm.signout}},[_vm._v(" logout ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }